import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px } from '@ux/theme-utils';

export default ({
  theme,
}) => {

  const {
    spacing,
    palette,
  } = theme;

  return {
    default: {
      inner: {
        backgroundColor: palette.grey12,
        ...cssSides('padding', Side.A, gu2px(3, spacing)),
        boxSizing: 'border-box',
      },
      actions: {
        marginTop: gu2px(2, spacing),
        flex: 1,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column-reverse',
        alignItems: 'center',
        paddingTop: gu2px(1, spacing),
      },
      decline: {
        paddingTop: gu2px(2, spacing),
        whiteSpace: 'nowrap',
      },
      buttons: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
      },
      button: {
        marginBottom: gu2px(1, spacing),
        ...cssSides('margin', Side.X, gu2px(1, spacing)),
      },
    },
    tablet: {
      actions: {
        flexDirection: 'row',
        paddingTop: 0,
      },
      decline: {
        paddingRight: gu2px(2, spacing),
        paddingTop: 0,
      },
      buttons: {
        flexWrap: 'nowrap',
      },
      button: {
        marginBottom: 0,
      },
    },
  };
};
